import Vue from 'vue'
import Vuex from 'vuex'
import isLogin from './login'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    isLogin
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
